export const radii = {
  xs: '2px',
  sm: '4px',
  md: '8px',
  lg: '16px'
};
